export enum userRole {
  SUPER_ADMIN = "SUPER_ADMIN",
  ADMIN = "ADMIN",
  USER = "USER",
  ANONYMOUS = "ANONYMOUS"
}
